import posthog from 'posthog-js';

try {
    posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
        api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
        autocapture: false,
        capture_pageview: true,
    });
} catch (error) {
    console.log('Failed to initialize PostHog:', error);
}
export default posthog;
